import type { ModuleRoute } from '../types';
import { CompanionLinkPage } from './CompanionLinkPage';
import { FeedbackPage } from './FeedbackPage';
import { HostActionPage } from './HostActionPage';
import { PreArrivalPage } from './PreArrivalPage';

/**
 * Public pages opened from signed links (ADR 0017): no sign-in and no portal shell. The prefixes are LINK_KINDS in
 * packages/shared/src/links.ts. Owned by Phase 2 task W13; only that task edits files in this folder.
 */
export const routes: ModuleRoute[] = [
  { path: '/p/:token', element: <PreArrivalPage />, public: true, area: 'any' },
  { path: '/f/:token', element: <FeedbackPage />, public: true, area: 'any' },
  { path: '/c/:token', element: <CompanionLinkPage />, public: true, area: 'any' },
  { path: '/h/:token', element: <HostActionPage />, public: true, area: 'any' },
];
